interface IProps {
    size?: number;
    color?: string;
}

export const IconLink = (props: IProps) => {
    const { size, color } = props;
    const defaultSize = "20";
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size || defaultSize}
            height={size || defaultSize}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M10.6142 13.0609L8.16547 15.5096C8.16547 15.5096 8.16547 15.5097 8.16541 15.5097C8.16541 15.5097 8.16541 15.5097 8.16535 15.5097C7.15274 16.5224 5.505 16.5224 4.49228 15.5097C4.00167 15.0191 3.73155 14.3668 3.73155 13.6731C3.73155 12.9795 4.00167 12.3273 4.4921 11.8367C4.49216 11.8366 4.49222 11.8366 4.49228 11.8365L6.94098 9.38777C7.27903 9.04966 7.27903 8.50145 6.94092 8.16339C6.60286 7.82534 6.05465 7.82534 5.71654 8.16339L3.26784 10.6122C3.26767 10.6123 3.26749 10.6126 3.26732 10.6127C2.45009 11.4302 2 12.5171 2 13.6731C2 14.8294 2.45026 15.9165 3.2679 16.7341C4.11186 17.578 5.22034 18 6.32887 18C7.43741 18 8.54595 17.578 9.38979 16.7341C9.38985 16.7341 9.38985 16.734 9.38985 16.734L11.8385 14.2852C12.1766 13.9472 12.1766 13.399 11.8385 13.0609C11.5005 12.7228 10.9523 12.7228 10.6142 13.0609Z"
                fill={color || "#9DAAAE"}
            />
            <path
                d="M18.0044 6.3268C18.0044 5.17053 17.5541 4.08347 16.7365 3.26583C15.0486 1.57803 12.3023 1.57809 10.6146 3.26583C10.6145 3.26594 10.6144 3.266 10.6143 3.26612L8.16569 5.7147C7.82758 6.05276 7.82758 6.60102 8.16569 6.93908C8.33481 7.10819 8.55633 7.19269 8.77791 7.19269C8.99944 7.19269 9.22107 7.10814 9.39007 6.93908L11.8387 4.49049C11.8388 4.49038 11.8389 4.49032 11.839 4.49021C12.8516 3.4776 14.4994 3.47754 15.5121 4.49021C16.0026 4.98081 16.2729 5.63309 16.2729 6.3268C16.2729 7.02046 16.0027 7.67262 15.5123 8.16323L15.5121 8.1634L13.0634 10.6122C12.7253 10.9502 12.7253 11.4984 13.0634 11.8365C13.2325 12.0056 13.4541 12.0901 13.6756 12.0901C13.8972 12.0901 14.1188 12.0056 14.2878 11.8365L16.7365 9.38778C16.7367 9.38761 16.7369 9.38737 16.737 9.3872C17.5543 8.56968 18.0044 7.48279 18.0044 6.3268Z"
                fill={color || "#9DAAAE"}
            />
            <path
                d="M6.94109 13.0609C7.11014 13.2299 7.33172 13.3145 7.55325 13.3145C7.77483 13.3145 7.99641 13.2299 8.16546 13.0609L13.063 8.16335C13.4011 7.82529 13.4011 7.27708 13.063 6.93897C12.7249 6.60091 12.1767 6.60091 11.8386 6.93897L6.94109 11.8364C6.60297 12.1746 6.60297 12.7228 6.94109 13.0609Z"
                fill={color || "#9DAAAE"}
            />
        </svg>
    );
};
